import React, { useState } from "react";
import { Col, Form, Input, notification, Row } from "antd";
import s from "./ChangeEmail.module.scss";
import {
  CheckCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  MailOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { changeEmail } from "../../redux/AuthSlice";
import { useTranslation } from "react-i18next";
import LoginHeader from "../../components/Header/LoginHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { Header } from "antd/es/layout/layout";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const ChangeEmail: React.FC = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const token = useSelector((state: RootState) => state.auth.access);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const openNotification =
    (pauseOnHover: boolean, message: string, type: "success" | "error") =>
    () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  const setNewEmail = async (values: {
    new_email: string;
    password: string;
  }) => {
    try {
      const res = await dispatch(
        changeEmail({
          new_email: values.new_email,
          password: values.password,
        })
      );

      if (res.type === "auth/changeEmail/fulfilled") {
        const message =
          res.payload && "message" in res.payload ? res.payload.message : "";

        openNotification(true, message, "success")();
        setTimeout(() => {
          navigate("/confirmNewEmail");
        }, 3000);
      }

      if (res.type === "auth/changeEmail/rejected") {
        const errorMessage =
          res.payload && "error" in res.payload
            ? res.payload.error
            : "Произошла ошибка";

        openNotification(true, errorMessage, "error")();
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div>
      {token ? (
        width > 500 ? (
          <Header />
        ) : (
          <MobileHeader />
        )
      ) : width > 500 ? (
        <LoginHeader />
      ) : (
        <MobileLoginHeader />
      )}

      <div className={s.login}>
        {contextHolder}

        <h2 className={s.h2}>
          <MailOutlined className={s.icon} />
          {t("Сменить Email")}
        </h2>
        <Form
          className={s.form}
          layout='vertical'
          form={form}
          onFinish={setNewEmail}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name='new_email'
                label={t("Hовый Email")}
                className={s.formItem}
                rules={[
                  { required: true, message: t("Введите email") },
                  { type: "email", message: t("Укажите корректный email") },
                ]}
              >
                <input placeholder={t("Введите email")} className={s.input} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name='password'
                label={t("Ваш текущий пароль")}
                className={s.formItem}
                rules={[
                  { required: true, message: t("Введите пароль") },
                  {
                    min: 8,
                    message: t("Пароль должен состоять минимум из 8 символов"),
                  },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                    message: t(
                      "Пароль должен иметь минимум одну заглавную, одну прописную буквы и цифру"
                    ),
                  },
                ]}
              >
                <Input.Password
                  className={s.password_input}
                  type={showPassword ? "text" : "password"}
                  iconRender={(visible) =>
                    visible ? (
                      <EyeOutlined className={s.icon} />
                    ) : (
                      <EyeInvisibleOutlined />
                    )
                  }
                  suffix={
                    showPassword ? (
                      <EyeOutlined
                        onClick={togglePasswordVisibility}
                        style={{ color: "rgb(248, 116, 64)" }}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        onClick={togglePasswordVisibility}
                      />
                    )
                  }
                  placeholder={t("Введите пароль")}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row>
          <Col span={24}>
            <Form.Item
              name='confirm_new_password'
              label={<span>Потвердитe пароль</span>}
              dependencies={["new_password"]}
              className={s.formItem}
              rules={[
                { required: true, message: "Введите пароль еще раз" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Пароли не совпадают!"));
                  },
                }),
              ]}
            >
              <Input.Password
                className={s.password_input}
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOutlined style={{ color: "rgb(248, 116, 64)" }} />
                  ) : (
                    <EyeInvisibleOutlined />
                  )
                }
                suffix={
                  showPassword ? (
                    <EyeOutlined
                      onClick={toggleConfirmPasswordVisibility}
                      className={s.icon}
                    />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={toggleConfirmPasswordVisibility}
                    />
                  )
                }
                placeholder='Введите ваш пароль еще раз'
              />
            </Form.Item>
          </Col>
        </Row> */}

          <Row>
            <button className={s.enter_btn}>{t("Сменить")} </button>
          </Row>
          <div className={s.no_account}>
            {t("Назад")}?&nbsp; &nbsp;
            <Link to='/myAccount' className={s.register_btn}>
              {t("Личный кабинет")}
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ChangeEmail;
